import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'

const BLANK_VALUE = '-'

const COLUMNS = [
  'dsLdap',
  'nmUser',
  'idBranch',
  'idSection',
  'cdMission',
  'dsEmail',
  'update',
  'delete',
]

export default class Table extends PureComponent {
  static propTypes = {
    handleDelete: PropTypes.func.isRequired,
    handleResize: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
    records: PropTypes.array.isRequired,
    sideFilterElement: PropTypes.node,
    sideFilterVisible: PropTypes.bool.isRequired,
    topMargin: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
  }

  renderRow = (row, i) => {
    const { handleDelete, handleResize, handleUpdate } = this.props

    handleResize()

    return (
      <tr key={row.idLocalUsers}>
        {this.renderColumn('dsLdap', row.dsLdap, i)}
        {this.renderColumn('nmUser', row.nmUser, i)}
        {this.renderColumn(
          'dsBranch',
          row.dsBranch ? row.dsBranch.replace(/LOJA /, '') : row.dsBranch,
          i
        )}
        {this.renderColumn(
          'idSection',
          row.idSection && row.dsSection
            ? `${row.idSection.toString().padStart(2, '0')} - ${row.dsSection}`
            : null,
          i
        )}
        {this.renderColumn('dsMission', row.dsMission, i)}
        {this.renderColumn('dsEmail', row.dsEmail, i)}
        {this.renderColumn(
          'update',
          <span onClick={() => handleUpdate(row)} className='table-icon'>
            <Glyph type='pencil' color='primary' />
          </span>,
          i
        )}
        {this.renderColumn(
          'delete',
          <span
            onClick={() => handleDelete(row.idLocalUsers)}
            className='table-icon'
          >
            <Glyph type='trash-can' color='default' />
          </span>,
          i
        )}
      </tr>
    )
  }

  renderColumn = (key, data, i) => {
    const { translate } = this.props
    return (
      <td key={key} ref={`column-ref-${key}-${i}`} className='cell-small'>
        <span className='sm-label'>
          {translate(`localUsers.table.column.${key}`)}
        </span>
        {data || BLANK_VALUE}
      </td>
    )
  }

  renderHeader = (column) => {
    const { topMargin, translate } = this.props

    return (
      <th
        key={column}
        ref={`column-ref-${column}`}
        style={{ top: `${topMargin}px` }}
      >
        <div
          className='cell small-column align-left'
          style={{ minWidth: 'auto' }}
        >
          <div className='header small'>
            {translate(`localUsers.table.column.${column}`)}
          </div>
        </div>
      </th>
    )
  }

  render() {
    const { records } = this.props

    return (
      <table
        className='table-adjustment bordered'
        style={{ fontSize: '0.9rem' }}
      >
        <thead>
          <tr>{COLUMNS.map(this.renderHeader)}</tr>
        </thead>
        <tbody>{records.map(this.renderRow)}</tbody>
      </table>
    )
  }
}
